const transcriptions = {
  REQUEST_TRANSCRIPTIONS: 'REQUEST_TRANSCRIPTIONS',
  RECEIVE_TRANSCRIPTIONS: 'RECEIVE_TRANSCRIPTIONS',
  SERVER_ERROR_OCCURRED: 'SERVER_ERROR_OCCURRED',
  RESET_SEARCH: 'RESET_SEARCH'
}
export default transcriptions;


// WEBPACK FOOTER //
// src/routes/Transcriptions/actions/actionTypes.js